<script setup lang="ts">
import {useWadObserver} from "~/composables/useWadObserver";

const {
  slots = 4,
} = defineProps<{
  slots?: number
}>()

const runtimeConfig = useRuntimeConfig()
const wadPlatformBaseUrl = runtimeConfig.public.wadPlatformBaseUrl
const wadApiBaseUrl = runtimeConfig.public.wadApiBaseUrl
const partnerAds = ref([])
const loading = ref(true)
const adsContainerRef = useTemplateRef('adsContainerRef')

const slotsClass = computed(() => {
  return `wad4-ads--${slots}-slots`;
})

useWadObserver(adsContainerRef, async () => {
  try {
    const res = await fetch(`${wadApiBaseUrl}/v2/ads/community-partners?ads_count=${slots}`)
    const data = await res.json()
    partnerAds.value = data.data
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="wad4-ads" :class="slotsClass" ref="adsContainerRef">
    <div class="wad4-ads__wrapper wad4__container--columns" >
      <template v-if="loading">
        <div v-for="n in slots" :key="n" class="wad4-ads__card wad4-ads__skeleton"></div>
      </template>
      <template v-else>
        <ClientOnly>
          <CommonCommunityPartnerAd class="wad4-ads__card" v-for="ad in partnerAds" :key="ad.entity_id" :ad="ad" :base-url="wadPlatformBaseUrl"/>
        </ClientOnly>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
.wad4-ads {
  width: 100%;

  &__wrapper {
    container-type: inline-size;
    flex-wrap: wrap;
    width: 100%;
  }

  &--4-slots {
    @container (min-width: 632px) {
      .wad4-ads__card {
        width: calc((100% - $wad4-col-gap) / 2);
      }
    }
    @container (min-width: 1184px) {
      .wad4-ads__card {
        width: calc((100% - ($wad4-col-gap * 3)) / 4);
      }
    }
  }

  &--3-slots {
    @container (min-width: 632px) {
      .wad4-ads__card {
        width: calc((100% - $wad4-col-gap) / 2);
      }
    }
    @container (min-width: 936px) {
      .wad4-ads__card {
        width: calc((100% - ($wad4-col-gap * 2)) / 3);
      }
    }
  }

  &__card {
    width: 100%;
    min-height: 124px;
  }

  &__skeleton {
    height: 130px;
    border-radius: 8px;
    background: linear-gradient(100deg, $wad4-c-background-bg-brand-primary 30%, $wad4-c-border-border-secondary 50%, $wad4-c-background-bg-brand-primary 70%);
    background-size: 200% 100%;
    animation: shimmer 3s ease-in-out infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}




</style>
